module.exports = __webpack_public_path__ + "img/Login1080.9221fba5.jpg";